import { useDataChainId, useDataChainName } from '@ui/hooks/datachain';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';

export const useHasUnlockDegenLeverage = () => {
  const chainId = useDataChainId();
  const chain = useDataChainName();

  const hasUnlockDegenLeverage = useMemo(() => {
    return true; // TODO: implement the condition of unlocking degen leverage
  }, []);

  return hasUnlockDegenLeverage;
};
